module.exports = __webpack_public_path__ + "img/man-construction.eec5eede.png";